import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import { login } from 'components/login/actions';
import AuthPageContainer from './container';
import LoginForm from 'components/login/login';
import Text from 'components/ui/text';
import View from 'components/ui/view';

let LoginPage = class LoginPage extends React.Component {
  render() {
    return (
      <AuthPageContainer
        renderNav={() => (
          <a
            href="/signup"
            className="btn-link btn-small signup-page__header-btn"
          >
            Sign Up
          </a>
        )}
        renderFooter={() => (
          <div className="signup-page__form-footer">
            <small>
              Don{"'"}t have an account?{' '}
              <a href="/signup" className="link-text">
                Sign up
              </a>.
            </small>
          </div>
        )}
      >
        <View padding="sm">
          <Text display tag="h1" size="xxl" weight="med" margin="none">
            Log In
          </Text>
        </View>
        <View padding={{ sides: 'sm', bottom: 'sm' }}>
          <LoginForm
            onSubmit={({ email, password }) =>
              this.props.login({ username: email, password })}
            onSuccess={() => (window.location = '/')}
          />
        </View>
      </AuthPageContainer>
    );
  }
};

LoginPage = connect(() => ({}), { login })(LoginPage);

export default LoginPage;



// WEBPACK FOOTER //
// ./shared/components/authPages/login.js